import { render } from "./vhpLoading.vue?vue&type=template&id=60837b72"
import script from "./vhpLoading.vue?vue&type=script&lang=js"
export * from "./vhpLoading.vue?vue&type=script&lang=js"

import "./vhpLoading.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__